import React from "react";

const TalentCards = ({ talentData, onTalentSelect, selectedTalent, onTalentDelete }) => {
  if (!talentData || !talentData.data) {
    return (
      <div className="text-center py-8">
        <p className="text-gray-500">No talent data available</p>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4">
      {talentData.data.map((talent, index) => {
        const totalReports = talent.reports?.length || 0;

        // Calculate average scores
        const avgScores = talent.reports?.reduce((acc, report) => {
          Object.keys(report).forEach((key) => {
            if (key !== "created_at") {
              acc[key] = (acc[key] || 0) + report[key];
            }
          });
          return acc;
        }, {});

        const avgScore = avgScores
          ? Math.round(
              Object.values(avgScores).reduce((sum, val) => sum + val, 0) /
                Object.keys(avgScores).length /
                totalReports
            )
          : 0;

        return (
          <div
            key={index}
            onClick={() => onTalentSelect(talent)}
            className={`cursor-pointer rounded-lg p-3 border transition-all duration-200 hover:shadow-md relative ${
              selectedTalent?.full_name === talent.full_name
                ? "border-indigo-500 bg-indigo-50 shadow-md"
                : "border-gray-200 bg-white hover:border-indigo-300 hover:bg-indigo-50"
            }`}
          >
            {/* Header Row */}
            <div className="flex items-center justify-between mb-2">
              <div className="w-8 h-8 bg-gradient-to-r from-indigo-500 to-purple-600 rounded-full flex items-center justify-center text-white font-semibold text-xs">
                {talent.full_name
                  .split(" ")
                  .map((n) => n[0])
                  .join("")}
              </div>
              {selectedTalent?.full_name === talent.full_name && (
                <div className="w-2 h-2 bg-indigo-500 rounded-full"></div>
              )}
            </div>

            {/* Delete button */}
            <button
              onClick={(e) => {
                e.stopPropagation();
                if (onTalentDelete) onTalentDelete(talent.user_id);
              }}
              className="absolute top-2 right-2 text-red-500 hover:text-red-700 p-1 rounded"
              aria-label={`Delete ${talent.full_name}`}
              title={`Delete ${talent.full_name}`}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-4 w-4"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6M9 7V4a1 1 0 011-1h4a1 1 0 011 1v3"
                />
              </svg>
            </button>

            {/* Name */}
            <div className="mb-2">
              <h3 className="text-sm font-semibold text-gray-900 truncate">
                {talent.full_name}
              </h3>
            </div>

            {/* Bottom Row - Reports and Average */}
            <div className="flex justify-between items-center">
              <div>
                <p className="text-xs text-gray-600">
                  {totalReports} Report{totalReports !== 1 ? "s" : ""}
                </p>
              </div>
              <div className="flex items-center space-x-1">
                <div className="w-8 bg-gray-200 rounded-full h-1.5">
                  <div
                    className={`h-1.5 rounded-full transition-all duration-300 ${
                      avgScore >= 80
                        ? "bg-gradient-to-r from-green-400 to-green-600"
                        : avgScore >= 60
                        ? "bg-gradient-to-r from-yellow-400 to-yellow-600"
                        : "bg-gradient-to-r from-red-400 to-red-600"
                    }`}
                    style={{ width: `${avgScore}%` }}
                  ></div>
                </div>
                <span className="text-xs font-semibold text-gray-900">
                  {avgScore}
                </span>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default TalentCards;
